import { readPersonalizationSettings } from '../../../user/storage/personalization';

// Get categories that the user wants to removed from localStorage.
const getRemovedCategories = () =>
  readPersonalizationSettings().notInterestedIn.categories.map(x => x.id);

// Filter products and remove products from categories that the user is not
// interested in.
export const filterCategories = products => {
  const removedCategories = getRemovedCategories();
  return products
    .filter(({ category }) => category)
    .filter(
      ({ category }) =>
        removedCategories.findIndex(id => id === category.id) < 0
    );
};
